export const UserData = [
	{
		userId: 0,
		userName: '김태양',
		phoneNumber: '2052-8337',
		email: 'tangerin2601@naver.com',
		sns: '@taeyaaaaaaang',
	},
	{
		userId: 1,
		userName: '이가빈',
		phoneNumber: '1886-1029',
		email: 'billy@gmail.com',
		sns: '@billyboo',
	},
	{
		userId: 2,
		userName: '김민지',
		phoneNumber: '2004-0507',
		email: 'minji@gmail.com',
		sns: '@newjeans_official',
	},
	{
		userId: 3,
		userName: '팜하니',
		phoneNumber: '2004-1006',
		email: 'hanni@gmail.com',
		sns: '@newjeans_official',
	},
	{
		userId: 4,
		userName: '모지혜',
		phoneNumber: '2005-0411',
		email: 'danielle@gmail.com',
		sns: '@newjeans_official',
	},
	{
		userId: 5,
		userName: '강해린',
		phoneNumber: '2006-0515',
		email: 'haerin@gmail.com',
		sns: '@newjeans_official',
	},
	{
		userId: 6,
		userName: '이혜인',
		phoneNumber: '2008-0421',
		email: 'hyein@gmail.com',
		sns: '@newjeans_official',
	},
];